import bridge from '@utiles/bridge';

// 文档：https://37wiki.37wan.com/pages/viewpage.action?pageId=13894831
export default {
  data() {
    return {
      isInSdk: bridge.runInsdk()
    };
  },
  methods: {
    // 关闭浏览器
    closeWebview() {
      console.log('closeWebview');
      bridge.callSdkMethod('closeWebview');
    }
  }
};
